import { filter } from 'rxjs/operators';
import {
  Component,
  ViewEncapsulation,
  OnInit,
  HostListener,
} from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';

import { ToasterConfig } from 'angular2-toaster';

import { insertAnalyticsElements } from 'insert-analytics-elements/googleTagManager';
import { LanguageService } from './services/language.service';
import { TooltipService } from './services/tooltip.service';
import { AccountService } from './+account/account.service';
import { AppConfigService } from './services/app-config.service';
import { ImageViewerService } from './shared/image-viewer/image-viewer.service';
import { environment } from 'environments/environment';
import { Location } from '@angular/common';
import { CurrentUser } from './services/currentUser.service';
import { FacebookService } from './services/facebook.service';
import { FirebaseService } from './services/firebase.service';
import { Store } from '@ngrx/store';
import { AppState } from './app.reducer';
import * as sharedActions from './shared/shared.actions';
import { AppHeaderComponent } from './header/appHeader/appHeader.component';

@Component({
  selector: 'app-root',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./app.component.scss'],
  templateUrl: './app.component.html',
  providers: [AppHeaderComponent],

})
export class AppComponent implements OnInit {
  public toasterconfig: ToasterConfig = new ToasterConfig({ limit: 1 });
  public isHeaderHidden = this.isLandingPage();
  isMobile;
  submitting;

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.detectMobile();
    this.detectScreenSize();
  }

  constructor(
    private languageService: LanguageService,
    private router: Router,
    private route: ActivatedRoute,
    public tooltipService: TooltipService,
    public accountService: AccountService,
    public currentUser: CurrentUser,
    public appConfigService: AppConfigService,
    public imageViewerService: ImageViewerService,
    public location: Location,
    public facebookService: FacebookService,
    public firebaseService: FirebaseService,
    private store: Store<AppState>,
    private appHeader: AppHeaderComponent,
  ) {
    this.languageService.useBrowserLang();
    this.appConfigService.load();
    if (environment.firebaseConfig.appId) {
      this.firebaseService.init();
    }
    if (environment.gtmId) {
      insertAnalyticsElements(environment.gtmId);
    }
  }

  ngOnInit() {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.isHeaderHidden = false;
        let currentRoute = this.route.root;
        if (!(this.router.url.includes('projects') || this.router.url.includes('sign_up') )
            && this.currentUser.get() ? this.currentUser.get().guest : false) {
          this.appHeader.logout();
        }
        while (currentRoute.children[0] !== undefined) {
          currentRoute = currentRoute.children[0];
          const data = currentRoute.snapshot.data;
          if (data && typeof data.hideDefaultHeader !== 'undefined') {
            this.isHeaderHidden = data.hideDefaultHeader;
          }
        }
      });
    this.detectMobile();
    this.detectScreenSize();

    this.store.select('shared').subscribe(store => {
      this.isMobile = store.isMobile;
    });
  }

  detectMobile() {
    this.store.dispatch(new sharedActions.IsMobile(window.innerWidth <= 768));
  }

  detectScreenSize() {
    this.store.dispatch(new sharedActions.DetectScreenSize());
  }

  isLandingPage() {
    return environment.landingEnabled && this.location.path() === '';
  }

  isAppReady() {
    return this.appConfigService.config || this.isLandingPage();
  }

  public isLoggedIn() {
    return !!this.currentUser.getJwtToken();
  }
}
